// Constants
import { HttpMethods } from "@ms/uno-constants/lib/local/HttpConstants";
// Utilities
import moment from "moment";
import { generateAjaxClientError } from "../../utilities/ServiceUtilities";
/**
 * Implementation of the Auth Service using the retail services token exchange endpoint
 */ export class RetailServicesTokenExchangeService {
    async fetchAccessTokenAsync(parameters) {
        const { claims, silent } = parameters;
        let resource;
        if ("resource" in parameters) {
            resource = parameters.resource;
        } else {
            throw generateAjaxClientError(null, new Error("Resource must be provided to fetch an access token."));
        }
        let response = null;
        try {
            const tokenProviderPath = this.tokenProviderPathMap[resource];
            const isTokenEncryptionEnabled = this.configProvider().flights.EnableTokenEncryption;
            if (tokenProviderPath) {
                const disableHostTokenFetchForObo = this.configProvider().changeGates.DisableHostTokenFetchForObo;
                if (!disableHostTokenFetchForObo && !!claims) {
                    // for OBO the retail services endpoint does not handle claims challenges directly.
                    // Instead, it relies on the host to handle the claims challenge and refresh the token.
                    // For instance under Teams the teams-js SDK will handle the claims challenge, handle any popup or MFA
                    // then refresh the current token which satisfies the claims challenge.
                    await this.hostAdaptor.getAccessToken(this.retailServiceResource, claims, silent);
                }
                const path = `${this.baseUrl}/api/rest/v1/tokenprovider/${tokenProviderPath}`;
                response = await this.ajaxClient.executeRequest(path, {
                    method: HttpMethods.Get,
                    telemetryConfig: this.getDefaultRequestTelemetryConfig("fetchAccessToken")
                });
                const data = await response.clone().json();
                return {
                    accessToken: data.accessToken,
                    expiry: isTokenEncryptionEnabled ? null : moment(data.expiresIn).toDate()
                };
            } else {
                // Retail services does not support a generic token exchange mechanic, so use the host token for everything else as a stopgap
                return await this.hostAdaptor.getAccessToken(resource, claims, silent);
            }
        } catch (error) {
            throw generateAjaxClientError(response, error);
        }
    }
    /**
     * Get the default telemetry config for requests
     */ getDefaultRequestTelemetryConfig(methodName) {
        return {
            apiName: this.name,
            methodName: methodName,
            requestHeadersToLog: [],
            responseHeadersToLog: []
        };
    }
    constructor(ajaxClient, hostAdaptor, configProvider){
        this.ajaxClient = ajaxClient;
        this.hostAdaptor = hostAdaptor;
        this.configProvider = configProvider;
        this.name = "RetailServicesTokenExchangeService";
        const { serviceConfigurations } = this.configProvider().settings;
        this.baseUrl = serviceConfigurations.auth.hostname;
        this.retailServiceResource = serviceConfigurations.auth.authResourceURI;
        this.tokenProviderPathMap = {
            [serviceConfigurations.graph.authResourceURI]: "graph",
            [serviceConfigurations.augloop.authResourceURI]: "augloop"
        };
    }
}
